/** Iterates an array of Records to filter child array values. */
export const filterRecordCollection = <
  T extends string | number | symbol,
  X extends object,
  U extends Array<X>
>(
  data: Array<Record<T, U>>,
  filterBy: (u: X) => boolean
) => {
  let res = [] as unknown as Array<X>;

  for (const item in data) {
    Object.values(data[item] as U).map(entries => {
      const resultData = (Object.values(entries) as U)?.filter(filterBy);

      res = [...res, ...resultData];
    });
  }

  return res;
};
/** Iterates an array of Records to find by keys then returns the filtered children. */
export const findInRecordCollectionByKey = <
  T extends string | number | symbol,
  X extends object,
  U extends Array<X>
>(
  data: Array<Record<T, U>>,
  key: string,
  filterBy: (u: X) => boolean
) => {
  for (const item of data) {
    for (const [_key, value] of Object.entries(item)) {
      if (_key == key) {
        return (value as U)?.filter(filterBy);
      }
    }
  }
};

/** Iterates an array of Records to find first matching item. */
export const findInRecordCollection = <
  T extends string | number | symbol,
  X extends object,
  U extends Array<X>
>(
  data: Array<Record<T, U>>,
  findBy: (u: X) => boolean
) => {
  let res: X | undefined;

  for (const item in data) {
    Object.values(data[item] as U).map(entries => {
      res = (Object.values(entries) as U)?.find(findBy);
    });
  }

  return res;
};

/** Iterates an array of Records to find first matching item. */
export const firstInRecordCollection = <
  T extends string | number | symbol,
  X extends object,
  U extends Array<X>
>(
  data: Array<Record<T, U>>
) => {
  const key = Object.keys(data?.[0])?.[0] as T;
  return Object.values(data?.[0]?.[key]).map((a: X) => a) as U;
};
